export const AGE_LABEL_KEYS = Object.freeze({
  UNDER_18: "stats.under18",
  "18_28": "stats.18to28",
  "29_38": "stats.29to38",
  "39_48": "stats.39to48",
  "49_58": "stats.49to58",
  "59_68": "stats.59to68",
  "69_PLUS": "stats.69plus",
  UNKNOWN: "stats.unknown",
});

export const SEX_LABEL_KEYS = Object.freeze({
  M: "stats.male",
  MALE: "stats.male",
  MASCULIN: "stats.male",
  HOMME: "stats.male",
  H: "stats.male",
  F: "stats.female",
  FEMALE: "stats.female",
  FEMININ: "stats.female",
  FEMME: "stats.female",
  X: "stats.other",
  OTHER: "stats.other",
  AUTRE: "stats.other",
  PENDING: "stats.pendingProcessing",
  UNKNOWN: "stats.unknown",
});

export const REPORT_MODES = Object.freeze({
  STANDARD: "STANDARD",
  CORRECTION: "CORRECTION",
});

export const GEOGRAPHY_LEVELS = Object.freeze([
  { value: "DEPARTMENT", label: "Department" },
  { value: "ARRONDISSEMENT", label: "Arrondissement" },
  { value: "COMMUNE", label: "Commune" },
  { value: "SECTION", label: "Communal section" },
  { value: "VOTING_CENTER", label: "Voting center" },
  { value: "CONSTITUENCY", label: "Constituency" },
]);

export const STANDARD_GEOGRAPHY_METRICS = Object.freeze([
  { value: "registeredVoterCount", label: "Registered voters", kind: "number" },
]);

export const CORRECTION_GEOGRAPHY_METRICS = Object.freeze([
  { value: "distinctApplicantCount", label: "Affected voters", kind: "number" },
]);

export const GEOJSON_FILES = Object.freeze({
  DEPARTMENT: "departments.geojson",
  ARRONDISSEMENT: "arrondissements.geojson",
  COMMUNE: "communes.geojson",
  SECTION: "sections.geojson",
  CONSTITUENCY: "constituencies.geojson",
});

